import {
  $tagsTableFilters,
  $tagsTablePage,
  $tagsTablePageSize,
  $tagsTableSearch,
  tagsTableFiltersInit,
  tagsTableQuery,
  tagsTableSearchReset,
} from '@/entities/tags'
import { type GetApiTagsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { combine, createEvent, createStore, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  DEFAULT_TAGS_LIST_PAGE_TAB,
  type TagsListPageTabsKeys,
  TagsListPageTabsKeysTypesEnum,
} from '../lib/tabs'

// Gate
export const TagsListPageGate = createGate()

// Altering
const $filterTypes = $tagsTableFilters.map((filters) => filters.Types || null)

sample({
  source: combine({
    queryStatus: tagsTableQuery.$status,
    gateStatus: TagsListPageGate.status,
  }),
  clock: $filterTypes,
  filter: ({ queryStatus, gateStatus }) =>
    queryStatus !== 'initial' && gateStatus,
  target: [tagsTableSearchReset],
})

// Tab
export const tagsListPageTabChanged = createEvent<TagsListPageTabsKeys>()
export const $tagsListPageTab = createStore<TagsListPageTabsKeys>(
  DEFAULT_TAGS_LIST_PAGE_TAB,
).on(tagsListPageTabChanged, (_, payload) => payload)
sample({
  clock: $tagsListPageTab,
  fn: (tab) => ({
    Types: [TagsListPageTabsKeysTypesEnum[tab]],
  }),
  target: tagsTableFiltersInit,
})

// Last state

// Filters
export const $tagsListPageLatestFilters = createStore<GetApiTagsQueryParams>({
  Types: [TagsListPageTabsKeysTypesEnum[DEFAULT_TAGS_LIST_PAGE_TAB]],
}).on($tagsListPageTab, (filters, tab) => ({
  ...filters,
  Types: [TagsListPageTabsKeysTypesEnum[tab]],
}))
sample({
  source: $tagsTableFilters,
  clock: TagsListPageGate.close,
  target: $tagsListPageLatestFilters,
})

// Page
export const $tagsListPageLatestPage = createStore<number>(DEFAULT_PAGE)
sample({
  source: $tagsTablePage,
  clock: TagsListPageGate.close,
  target: $tagsListPageLatestPage,
})

// Page size
export const $tagsListPageLatestPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: TagsListPageGate.close,
  source: $tagsTablePageSize,
  target: $tagsListPageLatestPageSize,
})
// Search
export const $tagsListPageLatestSearch = createStore<string>('')
sample({
  clock: TagsListPageGate.close,
  source: $tagsTableSearch,
  fn: (search) => search || '',
  target: $tagsListPageLatestSearch,
})
